import React from "react";
import "./section.css"; // 上記CSSを適用してください

function CheckIcon() {
  // シンプルな青チェックアイコン
  return (
    <svg className="check-icon" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="12" fill="#4c9ffd"/>
      <path d="M7 13.3L10.3 16.3L17 9.2" stroke="#fff" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
}

export default function AmazonTroubleSection() {
  return (
    <section className="bg-main">
      <div className="center-title">
        Amazon・Rakuten販売・出品で
      </div>
      <div className="center-title-main">
        こんな不安やお悩みありませんか？
      </div>
      <div className="card-box">
        <div className="checklist-col">
          <div className="check-item">
            <CheckIcon />
            商品には自信があるのに全然認知してもらえない…
          </div>
          <div className="check-item">
            <CheckIcon />
            Amazon・Rakuten戦略に詳しい人が社内にいない…
          </div>
          <div className="check-item">
            <CheckIcon />
            Amazon・Rakuten広告の費用対効果が合わない
          </div>
        </div>
        <div className="checklist-col">
          <div className="check-item">
            <CheckIcon />
            Amazon・Rakutenの売上が頭打ちになってきた…
          </div>
          <div className="check-item">
            <CheckIcon />
            楽天などでは売れるのにAmazonだけ売れない
          </div>
          <div className="check-item">
            <CheckIcon />
            そもそもAmazon・Rakutenを運用する人手が足りない
          </div>
        </div>
      </div>
    </section>
  );
}